<h5 mat-dialog-title>{{title}}</h5>
<div mat-dialog-content>
    <p>{{message}}</p>
</div>
<div mat-dialog-actions style="text-align: end;">
    <button mat-button (click)="onDismiss()">No</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">Si</button>
</div>
